import React from "react";
import Alert from "@mui/material/Alert";

const AlertShared = ({ alertMsg, severity }) => {
  return (
    <div className="fixed top-4 left-[50%] translate-x-[-50%] z-50">
      <Alert variant="filled" severity={severity}>
        {alertMsg}
      </Alert>
    </div>
  );
};

export default AlertShared;
